import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CustomFileDownloaderComponent } from './custom-file-downloader.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ApplicationPipesModule } from 'src/app/pipe/pipes.module';



@NgModule({
  declarations: [
    CustomFileDownloaderComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ApplicationPipesModule
  ],
  exports:[
    CustomFileDownloaderComponent,
  ]
})
export class CustomFileDownloaderModule { }
